import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import axios from "axios";
import { Response } from "../../types/global";

import {
  getProducts as getProductsUrl,
  getProductDetail as getProductDetailUrl,
} from "../../helpers/apiUrl";
import {
  payloadProduct,
  productDetailResponse,
  productResponse,
} from "../../types/products";
import { axiosClient } from "../../helpers/apiClient";

export const getProductsRegisterList = createAsyncThunk(
  "product/get-Register-product",
  async (payload: payloadProduct) => {
    return await axios
      .post(getProductsUrl, payload)
      .then((d: AxiosResponse<Response<productResponse[]>>) => d.data)
      .then((d: Response<productResponse[]>) => d.data);
  },
);

export const getProductsPurchaseList = createAsyncThunk(
  "product/get-Purchase-product",
  async (payload: payloadProduct) => {
    return await axios
      .post(getProductsUrl, payload)
      .then((d: AxiosResponse<Response<productResponse[]>>) => d.data)
      .then((d: Response<productResponse[]>) => d.data);
  },
);

export const getProductDetailById = createAsyncThunk(
  "product/get-product-by-id",
  async (id: number) => {
    const urlWithId = `${getProductDetailUrl}/?id=${id}`;
    return axios
      .get(urlWithId)
      .then((d: AxiosResponse<Response<productDetailResponse>>) => d.data)
      .then((d: Response<productDetailResponse>) => d.data);
  },
);
